import { SxProp } from 'src/types/mui';

export const pageLayoutPaperSx: SxProp = {
  p: '32px',
  h2: {
    width: '100%',
  },
};

export const mobileContentWrapperStyles: SxProp = {
  zIndex: '1',
  position: 'relative',
  height: '100%',
  width: '100%',
  overflowY: 'scroll',
  py: 2,
};

export const paperSx: SxProp = {
  padding: '10px 15px',
  display: 'flex',
  alignItems: 'center',
  borderRadius: '8px',
};

export const IconSx: SxProp = {
  mr: '10px',
};

export const LinkSx: SxProp = {
  textDecoration: 'underline',
};
